const PAYMENT_IMAGE_MAX_DIMENSION = 1080; // Longest side, in px
const PAYMENT_IMAGE_QUALITY = 0.8;

const formatDateForFilename = (date) => {
    const pad = (value) => String(value).padStart(2, '0');
    return date.getFullYear().toString() +
        pad(date.getMonth() + 1) +
        pad(date.getDate()) +
        pad(date.getHours()) +
        pad(date.getMinutes()) +
        pad(date.getSeconds());
}

const getPaymentImageName = () => `payment-${formatDateForFilename(new Date())}.webp`

const convertImageToWebp = (file) => {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const image = new Image();

        image.onload = () => {
            URL.revokeObjectURL(objectUrl);

            const scale = Math.min(1, PAYMENT_IMAGE_MAX_DIMENSION / Math.max(image.width, image.height));
            const canvas = document.createElement('canvas');
            canvas.width = Math.round(image.width * scale);
            canvas.height = Math.round(image.height * scale);

            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, canvas.width, canvas.height);

            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('No se pudo convertir la imagen a webp.'));
                    return;
                }
                resolve(new File([blob], getPaymentImageName(), { type: 'image/webp' }));
            }, 'image/webp', PAYMENT_IMAGE_QUALITY);
        };

        image.onerror = () => {
            URL.revokeObjectURL(objectUrl);
            reject(new Error('No se pudo cargar la imagen seleccionada.'));
        };

        image.src = objectUrl;
    });
}

const getStep2MandatoryFields = (selectedTypeId) => {
    const fields = ['typeCatLv1', 'organizerName', 'eventDate', 'eventTime', 'address', 'phone'];
    if (Number(selectedTypeId) === 1 ||
        Number(selectedTypeId) === 2) {
        fields.push('celebrantName');
    }
    if (Number(selectedTypeId) === 1) {
        fields.push('birthNumber');
    }
    if (Number(selectedTypeId) === 4) {
        fields.push('couplePerson1Name', 'couplePerson2Name');
    }
    return fields;
};

const getStep3MandatoryFields = (selectedPaymentMethodId) => {
    const fields = ['paymentMethodId'];
    if (selectedPaymentMethodId) {
        fields.push('paymentScreenshot');
    }
    return fields;
}

// Parses the value M.Timepicker writes into its input in twelveHour mode
// ("hh:mm AM" / "hh:mm PM") into 24-hour { hours, minutes }.
const parseEventTime = (value) => {
    const [, hh, mm, amOrPm] = value.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
    const hours12 = Number(hh) % 12;
    return {
        hours: amOrPm.toUpperCase() === 'PM' ? hours12 + 12 : hours12,
        minutes: Number(mm)
    };
};

export {
    convertImageToWebp,
    getPaymentImageName,
    getStep2MandatoryFields,
    getStep3MandatoryFields,
    parseEventTime
}
